import { render, staticRenderFns } from "./Banner3.vue?vue&type=template&id=3fd6ce8c&"
import script from "./Banner3.vue?vue&type=script&lang=js&"
export * from "./Banner3.vue?vue&type=script&lang=js&"
import style0 from "./Banner3.vue?vue&type=style&index=0&id=3fd6ce8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports